export const SET_I18N_CATALOG = 'SET_I18N_CATALOG'
